/**
 * Boot Scene
 * Initializes textures, shaders, and preloads assets
 */

import Phaser from 'phaser';
import { TextureGenerator } from '../systems/TextureGenerator.js';
import { audioEngine } from '../systems/AudioEngine.js';
import { registerDataCorruptionPipeline } from '../pipelines/DataCorruptionPipeline.js';

export class BootScene extends Phaser.Scene {
    constructor() {
        super({ key: 'BootScene' });
    }

    preload() {
        // Display loading text
        const loadingText = this.add.text(this.scale.width / 2, this.scale.height / 2, 'Loading...', {
            fontSize: '24px',
            fontFamily: 'Arial',
            color: '#333333'
        }).setOrigin(0.5);

        // Load custom image assets
        this.load.image('player', 'assets/player.png');
        this.load.image('datapoint', 'assets/datapoint.png');
        this.load.image('leverage', 'assets/leverage.png');
        this.load.image('overfitter', 'assets/overfitter.png');

        // Generate procedural textures (for anything not replaced by images)
        const textureGen = new TextureGenerator(this);
        textureGen.generateAll();

        // Update loading text
        loadingText.setText('Initializing...');
    }

    create() {
        // Initialize audio engine (will require user interaction to fully enable)
        audioEngine.init();

        // Register custom shader pipelines if WebGL is available
        this.registerShaderPipelines();

        // Start with title screen (full flow: Title → Honeypot → Transition → Gameplay)
        this.scene.start('TitleScene');
    }

    registerShaderPipelines() {
        // Register DataCorruption post-processing pipeline
        const registered = registerDataCorruptionPipeline(this.game);

        if (registered) {
            console.log('DataCorruption shader pipeline registered');
        } else {
            console.log('Shader pipelines not available (Canvas renderer)');
        }
    }
}
